export default __webpack_public_path__ + "static/media/ADIDAS_fp01.46652f17.png";